import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputTextModule } from 'primeng/inputtext';
import { PasswordModule } from 'primeng/password';
import { ButtonModule } from 'primeng/button';
import { BadgeModule } from 'primeng/badge';
import { DividerModule } from "primeng/divider";
import { SelectButtonModule } from 'primeng/selectbutton';
import { CheckboxModule } from 'primeng/checkbox';
import { CardModule } from 'primeng/card';
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { CalendarModule } from 'primeng/calendar';
import { SliderModule } from 'primeng/slider';
import { MultiSelectModule } from 'primeng/multiselect';
import { ContextMenuModule } from 'primeng/contextmenu';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { ProgressBarModule } from 'primeng/progressbar';
import { RatingModule } from 'primeng/rating';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { FileUploadModule } from 'primeng/fileupload';
import { TabViewModule } from 'primeng/tabview';
import { ListboxModule } from 'primeng/listbox';
import { SplitButtonModule } from 'primeng/splitbutton';
import { TooltipModule } from 'primeng/tooltip';
import { MenubarModule } from 'primeng/menubar';
import { MenuModule } from 'primeng/menu';
import { TabMenuModule } from 'primeng/tabmenu';
import { SidebarModule } from 'primeng/sidebar';
import { InputSwitchModule } from 'primeng/inputswitch';

//Agregados
import { RadioButtonModule } from 'primeng/radiobutton';
import { ConfirmDialogModule } from 'primeng/confirmdialog';


@NgModule({
  imports: [
    CommonModule,
    InputTextModule,
    PasswordModule,
    ButtonModule,
    BadgeModule,
    DividerModule,
    SelectButtonModule,
    CheckboxModule,
    CardModule,
    TableModule,
    ToastModule,
    CalendarModule,
    SliderModule,
    MultiSelectModule,
    ContextMenuModule,
    DialogModule,
    DropdownModule,
    ProgressBarModule,
    RatingModule,
    FileUploadModule,
    TabViewModule,
    ListboxModule,
    InputTextareaModule,
    SplitButtonModule,
    TooltipModule,
    MenubarModule,
    MenuModule,
    TabMenuModule,
    SidebarModule,
    InputSwitchModule,
    ConfirmDialogModule
  ],
  exports: [
    InputTextModule,
    PasswordModule,
    ButtonModule,
    BadgeModule,
    DividerModule,
    SelectButtonModule,
    CheckboxModule,
    CardModule,
    TableModule,
    ToastModule,
    CalendarModule,
    SliderModule,
    MultiSelectModule,
    ContextMenuModule,
    DialogModule,
    DropdownModule,
    ProgressBarModule,
    RatingModule,
    FileUploadModule,
    TabViewModule,
    ListboxModule,
    InputTextareaModule,
    SplitButtonModule,
    TooltipModule,
    MenubarModule,
    MenuModule,
    TabMenuModule,
    SidebarModule,
    RadioButtonModule,
    InputSwitchModule,
    ConfirmDialogModule
  ]
})
export class PrimeModule { }